import { useWebsiteSettings } from 'client/store'
import { AlignType } from 'common/types/styleTypes'
import { getWebsiteStylesTypographyHeading } from 'src/editor/store/website-settings/website-settings-selector'
import { usePage } from 'client/store'
import { pageSelectors } from 'client/store/page/pageSelectors'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useCalculateHeadingTextAlign = ({
  textAlign,
  mobileTextAlign,
}: {
  textAlign?: AlignType
  mobileTextAlign?: AlignType
}) => {
  const pageGlobalHeadingTextAlign = usePage(
    pageSelectors.getGlobalHeadingAlign,
  )
  const pageGlobalMobileHeadingTextAlign = usePage(
    pageSelectors.getGlobalMobileHeadingAlign,
  )
  const {
    textAlign: websiteGlobalTextAlign,
    mobileTextAlign: websiteGlobalMobileTextAlign,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  const globalTextAlign = websiteGlobalTextAlign || pageGlobalHeadingTextAlign
  const globalMobileTextAlign =
    websiteGlobalMobileTextAlign || pageGlobalMobileHeadingTextAlign

  return {
    calculatedTextAlign: getCalculatedProperty({
      desktopProperty: textAlign,
      mobileProperty: mobileTextAlign,
      globalDesktopProperty: globalTextAlign,
      //TODO https://systeme-team.slack.com/archives/C020MV26SBH/p1754505782538659
      globalMobileProperty: textAlign || globalMobileTextAlign,
    }) as { mobile: AlignType; desktop: AlignType },
    globalTextAlign,
    globalMobileTextAlign,
  }
}
